import ReportsContainer from './container/ReportsContainer'

// Sync route definition
export default {
  path: '/reports',
  component : ReportsContainer,
}
